import _ from "lodash";
import UserControlService from "../provider/UserControl/UserControlService";
import { SUCCESS, ERROR } from "../common/Util";
import { CHANGE_APP_PROPS, CHANGE_USER_CONTROL_PROPS } from "./ActionConstants";

export function actionGetUserControlList(searchText, offset, limit) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGetUserControlList(searchText, offset, limit).then(response => {
			dispatch({
				type: CHANGE_USER_CONTROL_PROPS,
				props: {
					userControlList: response,
					total: !_.isEmpty(response) ? response[0].cantidad : 0
				}
			});
			dispatch({
				type: CHANGE_APP_PROPS,
				props: {
					loading: false
				}
			});
		});
	};
}

async function asyncGetUserControlList(searchText, offset, limit) {
	let response = await UserControlService.getUserControlList(
		searchText,
		offset,
		limit
	);
	return response;
}

export function actionChangeUserControlProps(props) {
	return dispatch => {
		dispatch({
			type: CHANGE_USER_CONTROL_PROPS,
			props: props
		});
	};
}

export function actionCreateUserControl(values, role, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});

		asyncCreateUserControl(values, role)
			.then(() => callback(SUCCESS))
			.catch(() => callback(ERROR))
			.then(() =>
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				})
			);
	};
}

async function asyncCreateUserControl(values, role) {
	let response = await UserControlService.setUserControl(values, role);
	return response;
}

export function actionUpdateUserControl(values, rol, callback) {
	return (dispatch, store) => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: { loading: true }
		});
		asyncUpdateUserControl(values, rol)
			.then(response => {
				let userControlList = store().userControl.userControlList;
				const userControlIndex = userControlList.findIndex(e => {
					return e.id === response.id;
				});
				userControlList[userControlIndex] = response;
				dispatch({
					type: CHANGE_USER_CONTROL_PROPS,
					props: {
						userControl: response,
						userControlList: userControlList
					}
				});
				callback(SUCCESS);
			})
			.catch(() => callback(ERROR))
			.then(() =>
				dispatch({
					type: CHANGE_APP_PROPS,
					props: { loading: false }
				})
			);
	};
}

async function asyncUpdateUserControl(values, rol) {
	let response = await UserControlService.updateUserControl(values, rol);
	return response;
}

export function actionDeleteUserControl(userControlId, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncDeleteUserControl(userControlId)
			.then(() => callback(SUCCESS))
			.catch(() => callback(ERROR))
			.then(() =>
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				})
			);
	};
}

async function asyncDeleteUserControl(userControlId) {
	let response = await UserControlService.deleteUserControl(userControlId);
	return response;
}

export async function asyncCheckEmail(email, id) {
	let response = await UserControlService.validateEmail(email, id);
	return response;
}



// WEBPACK FOOTER //
// ./src/actions/UserControlActions.js